import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { CardChooseTransport } from "../../component/CardChooseTransport"
import { CardChooseNotTransport } from "../../component/CardChooseNotTransport"
import { colorPrimary } from "../../rsc/colors"

type Props = {
    setNeedTransport: any
    page: string
}

export function StepAskTransport({ setNeedTransport, page }: Props) {

    const { t } = useTranslation();

    useEffect(() => {
        window.gtag("event", "page_view", { page_path: page });
        // eslint-disable-next-line
    }, [])

    const onTransportChoice = () => {
        setNeedTransport(true)
    }

    const onNotTransportChoice = () => {
        setNeedTransport(false)
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", gap:"20px", marginBottom:"20px" }}>
            <p className="text-huge-xs" style={{ width: "100%", textAlign: "center", color:colorPrimary, fontWeight:700 }}>{t('choose_one_option')}</p>
            <div style={{ display:"flex", justifyContent:"center" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "20px", maxWidth:"400px"}}>
                    <CardChooseNotTransport onClick={onNotTransportChoice} />
                    <CardChooseTransport onClick={onTransportChoice} />
                </div>
            </div>
        </div>
    )
}